(function () {
  'use strict';

  if (window.AxiomOverlayDismissCursor) return;

  var cursor = document.querySelector('[data-overlay-dismiss-cursor]');
  var supportsPointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var entries = [];
  var activeEntry = null;
  var clickAnimationTimer = null;
  var isClickAnimating = false;
  var clickAnimationDuration = 560;

  function hideCursor(force) {
    if (isClickAnimating && !force) return;
    if (cursor) cursor.classList.remove('is-visible', 'is-clicking');
  }

  function forceHideCursor() {
    if (clickAnimationTimer) window.clearTimeout(clickAnimationTimer);
    clickAnimationTimer = null;
    isClickAnimating = false;
    hideCursor(true);
  }

  function prefersReducedMotion() {
    if (window.Axiom && typeof window.Axiom.prefersReducedMotion === 'function') {
      return window.Axiom.prefersReducedMotion();
    }
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function resolveFallbackOverlay() {
    var overlay = document.getElementById('site-overlay');
    return overlay && overlay.classList.contains('is-open') ? overlay : null;
  }

  function clearOverlayState(entry) {
    if (entry && entry.overlay) entry.overlay.classList.remove('overlay--dismiss-cursor-active');
    if (entry && entry.cursorSurface) entry.cursorSurface.classList.remove('overlay-dismiss-cursor-surface');
  }

  function syncActiveEntry() {
    clearOverlayState(activeEntry);
    activeEntry = entries.length ? entries[entries.length - 1] : null;
    if (activeEntry && activeEntry.overlay) {
      activeEntry.overlay.classList.add('overlay--dismiss-cursor-active');
    }
    if (activeEntry && activeEntry.cursorSurface) {
      activeEntry.cursorSurface.classList.add('overlay-dismiss-cursor-surface');
    }
    hideCursor();
  }

  function handleDrawerOpen(event) {
    var detail = event.detail || {};
    var surface = detail.drawer || detail.modal;
    if (!surface) return;

    entries = entries.filter(function (entry) {
      return entry.drawer !== surface;
    });
    entries.push({
      drawer: surface,
      boundary: detail.modal ? (surface.querySelector('[role="document"]') || surface) : surface,
      cursorSurface: detail.modal && surface.querySelector('[role="document"]') ? surface : null,
      isModal: Boolean(detail.modal),
      overlay: detail.overlay || resolveFallbackOverlay()
    });
    syncActiveEntry();
  }

  function handleDrawerClose(event) {
    var detail = event.detail || {};
    var drawer = detail.drawer || detail.modal;
    if (!drawer) return;

    entries = entries.filter(function (entry) {
      if (entry.drawer !== drawer) return true;
      clearOverlayState(entry);
      return false;
    });
    syncActiveEntry();
  }

  function isDismissArea(target) {
    if (!activeEntry || !activeEntry.drawer || !target) return false;
    // The overlay is checked first: some drawers (the flyout) render their own backdrop inside the drawer element.
    if (activeEntry.overlay && (target === activeEntry.overlay || activeEntry.overlay.contains(target))) {
      return window.getComputedStyle(activeEntry.overlay).pointerEvents !== 'none';
    }
    if (activeEntry.boundary && activeEntry.boundary.contains(target)) return false;
    return activeEntry.isModal && activeEntry.drawer.contains(target);
  }

  function handlePointerMove(event) {
    if (isClickAnimating) return;

    if (!cursor || !isDismissArea(event.target)) {
      hideCursor();
      return;
    }

    cursor.style.setProperty('--overlay-dismiss-cursor-x', event.clientX + 'px');
    cursor.style.setProperty('--overlay-dismiss-cursor-y', event.clientY + 'px');
    cursor.classList.add('is-visible');
  }

  function handlePointerDown(event) {
    if (!cursor || !isDismissArea(event.target)) {
      hideCursor();
      return;
    }

    cursor.style.setProperty('--overlay-dismiss-cursor-x', event.clientX + 'px');
    cursor.style.setProperty('--overlay-dismiss-cursor-y', event.clientY + 'px');

    if (prefersReducedMotion()) {
      forceHideCursor();
      return;
    }

    if (clickAnimationTimer) window.clearTimeout(clickAnimationTimer);
    isClickAnimating = true;
    cursor.classList.remove('is-clicking');
    void cursor.offsetWidth;
    cursor.classList.add('is-visible', 'is-clicking');

    clickAnimationTimer = window.setTimeout(function () {
      clickAnimationTimer = null;
      isClickAnimating = false;
      hideCursor(true);
    }, clickAnimationDuration);
  }

  if (!cursor || !supportsPointer || document.body.dataset.overlayCloseCursorEnabled !== 'true') {
    window.AxiomOverlayDismissCursor = { refresh: function () {} };
    return;
  }

  document.addEventListener('theme:drawer:open', handleDrawerOpen);
  document.addEventListener('theme:drawer:close', handleDrawerClose);
  document.addEventListener('theme:modal:open', handleDrawerOpen);
  document.addEventListener('theme:modal:close', handleDrawerClose);
  document.addEventListener('pointermove', handlePointerMove, { passive: true });
  document.addEventListener('pointerdown', handlePointerDown, { passive: true });
  document.documentElement.addEventListener('pointerleave', forceHideCursor, { passive: true });
  window.addEventListener('blur', forceHideCursor);

  window.AxiomOverlayDismissCursor = {
    refresh: syncActiveEntry
  };
})();
